module.exports = {
	"articleTitle1": "Best Mexican: Isalita ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Isalita",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/best-mexican-isalita",
	"articleSnippet1": "Apr 2, 2017 ... On its drink menu, flanking the well-fonted restaurant title Isalita Cantina \nMexicana, are two masks. No, they're not reproductions from the poorly ...",
	"articleSnippet2": "Apr 1, 2016 ... Last year's winner for Best Mexican Food, Isalita, is making its second \nappearance on The Michigan's Daily's Best of Ann Arbor list of winners.",
	"foodRecommendations": [
		{
			"text": "The Fish Tacos were amazing",
			"person": "Anon"
		}
	],
	"articleTitle2": "Best Mexican Food: Isalita ",
	"address": "341 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160414/eaa.BOAA_.Isalita.4.1.16.004.jpg?itok=pAFDolxT",
			"author": "Evan Aaron",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/isalitas.evanaaron.jpg?itok=C8Q9TV5c",
			"author": "Evan Aaron",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279718,
		"lng": -83.744275
	},
	"totalMisc": 2,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"datespot": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/isalita.json
// module id = 897
// module chunks = 0